import InvestorDeck from "@/components/InvestorDeck";
import ClosingCTA from "@/components/ClosingCTA";

export default function Investors() {
  return (
    <main data-testid="investors-page" className="pt-16">
      <InvestorDeck />
      <ClosingCTA />
    </main>
  );
}
